import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

const TONES = {
  info: { box: 'bg-info-soft border-info/25 text-fg', icon: 'text-info', Icon: Info },
  success: { box: 'bg-success-soft border-success/25 text-fg', icon: 'text-success', Icon: CircleCheck },
  warning: { box: 'bg-warning-soft border-warning/30 text-fg', icon: 'text-warning', Icon: TriangleAlert },
  danger: { box: 'bg-danger-soft border-danger/25 text-fg', icon: 'text-danger', Icon: CircleAlert },
} as const;

/** Estado sempre com cor + ícone + texto (cor nunca é o único indicador). */
export function Alert({ tone = 'info', title, children, className }: {
  tone?: keyof typeof TONES; title?: string; children?: ReactNode; className?: string;
}) {
  const t = TONES[tone];
  return (
    <div role={tone === 'danger' ? 'alert' : 'status'} className={cn('flex gap-3 rounded-md border px-3.5 py-3 text-sm', t.box, className)}>
      <t.Icon className={cn('mt-0.5 size-4 shrink-0', t.icon)} aria-hidden />
      <div className="flex flex-col gap-0.5">
        {title && <p className="font-medium">{title}</p>}
        {children && <div className="text-fg-muted">{children}</div>}
      </div>
    </div>
  );
}
